import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { Services } from './components/Services';
import { Academy } from './components/Academy';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { OpeningCurtain } from './components/OpeningCurtain';
import { SeoHead } from './components/SeoHead';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { BookingProvider } from './components/BookingContext';
export function App() {
  const [isOpening, setIsOpening] = useState(true);
  const completeOpening = useCallback(() => setIsOpening(false), []);
  return <BookingProvider data-id="element-0" data-mp="28sl5t3y8dyi5">
      <div className="w-full min-h-screen bg-warm-white text-dark font-sans antialiased" data-id="element-1" data-mp="23vcjcr61v8b3">
        <SeoHead data-id="element-2" data-mp="23ti7s3go4sjo" />
        <Navbar data-id="element-3" data-mp="3ik7fqfdqo9q4" />
        <main data-id="element-4" data-mp="3ikr0s4yore8d">
          <Hero data-id="element-5" data-mp="3iiwasc8k4vxf" />
          <Intro data-id="element-6" data-mp="3ijfthv617oci" />
          <Services data-id="element-7" data-mp="3ihuyk4ft23e4" />
          <Academy data-id="element-8" data-mp="3mlawr57iwbsx" />
          <Reviews data-id="element-9" data-mp="3mkrefndynled" />
          <Contact data-id="element-10" data-mp="3mk85gw6ag7ch" />
        </main>
        <Footer data-id="element-11" data-mp="3mj6ipufwtwex" />
        <FloatingWhatsApp data-id="element-12" data-mp="3rcj6618urx63" />

        <AnimatePresence data-id="element-13" data-mp="3rdaqgfx028h2">
          {isOpening && <OpeningCurtain onComplete={completeOpening} data-id="element-14" data-mp="3recdzjv7cnfo" />}
        </AnimatePresence>
      </div>
    </BookingProvider>;
}